
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { OffsetFields, OffsetKey, Device } from '~/interfaces/device.interface';
import { DevicesModule } from '~/store/modules/devices';

@Component
export default class Offset extends Vue {
    @Prop() offset!: OffsetFields;
    @Prop() device!: Device;

    offsetKeys = ['temperature', 'pressure', 'humidity_offset', 'humidity'];

    localOffset: OffsetFields = {};

    @Watch('offset', { immediate: true, deep: true })
    handler() {
        this.resetOffset();
    }

    modifyOffsetValue(value: number, key: OffsetKey) {
        switch (key) {
            case 'humidity_offset':
                this.localOffset[key] = value / 100;
                break;
            default:
                this.localOffset[key] = value;
                break;
        }
    }

    setOffset(key: OffsetKey) {
        if (this.device) {
            const gatewayId = this.device.is_module ? DevicesModule.currentGatewayId : this.device.id;
            const targetId = this.device.id;
            const value = this.localOffset[key] ? this.localOffset[key] as number : 0;
            this.device.setOffset(gatewayId, targetId, key, value);
        }
    }

    resetOffset() {
        this.localOffset = JSON.parse(JSON.stringify(this.offset));
    }

    getOffsetValueByKey(key: OffsetKey) {
        switch (key) {
            case 'humidity_offset':
                return this.localOffset.humidity_offset ? this.localOffset.humidity_offset * 100 : null;
            default:
                return this.localOffset[key];
        }
    }

    get currentGatewayType() {
        return DevicesModule.currentGateway?.type;
    }
}
